import { Selection, BaseType } from "d3";

import { Cartesian } from "@examspark/types";

export const useMarginLabels =
  ({
    width,
    height,
    margin,
    props,
  }: {
    width: number;
    height: number;
    margin: Cartesian.Padding;
    props: Cartesian.Graph;
  }) =>
  <GType extends BaseType>(svg: Selection<GType, any, any, any>) => {
    const labels = [
      {
        side: "bottom",
        label: props.marginLabelBottom,
        x: width / 2,
        y: height + margin.bottom - 15,
      },
      {
        side: "left",
        label: props.marginLabelLeft,
        transform: "rotate(-90)",
        y: 20 - margin.left,
        x: -height / 2,
      },
      {
        side: "right",
        label: props.marginLabelRight,
        transform: "rotate(90)",
        y: -margin.right + 15 - width,
        x: height / 2,
      },
      {
        side: "top",
        label: props.marginLabelTop,
        x: width / 2,
        y: -margin.top + 15,
      },
    ].filter((d) => d.label);
    svg
      .selectAll<SVGTextElement, (typeof labels)[number]>("text.margin-label")
      .data(labels, (d) => d?.side)
      .join("text")
      .attr("class", "margin-label")
      .attr("x", (d) => d.x)
      .attr("y", (d) => d.y)
      .attr("transform", (d) => d.transform ?? "")
      .attr("text-anchor", "middle")
      .attr("dominant-baseline", "middle")
      .text((d) => d.label ?? "");
  };
